import { render, staticRenderFns } from "./characteristics-table.component.vue?vue&type=template&id=f0a6fd34&scoped=true&"
import script from "./characteristics-table.component.vue?vue&type=script&lang=ts&"
export * from "./characteristics-table.component.vue?vue&type=script&lang=ts&"
import style0 from "./characteristics-table.component.vue?vue&type=style&index=0&id=f0a6fd34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a6fd34",
  null
  
)

export default component.exports